var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 147,
    viewBox: "0 0 500 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 147,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.831 39H335.976V58.0601C335.976 59.8776 335.456 70.0801 323.403 74.1878C311.339 70.0801 310.831 59.8776 310.831 58.0601V39Z",
    fill: "url(#paint0_radial_0_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.407 66.9661L321.167 63.1614L324.902 66.8934H329.834V56.0608H333.062V52.1106H329.834V50.9474H333.062V47.3244H329.714V42.6836H319.317V46.2702H325.664V61.8769L321.155 57.3937L314.506 64.058L317.395 66.9661H317.407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.028 46.2581H261.375V69.3289C261.375 75.2541 260.372 78.2591 254.908 78.2591C249.444 78.2591 248.61 74.9875 248.61 69.3289V46.2581H240.691V69.7166C240.691 76.3688 242.42 82.5122 254.92 82.5122C267.42 82.5122 269.318 76.3688 269.318 69.7166V46.2581H269.04H269.028Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.599 81.9548H303.517V46.2581H303.239H295.599V61.0408H282.652V46.2581H274.722V81.9548H282.652V65.9603H295.599V81.9548Z",
    fill: "#008CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.805 46.2581V70.2134C226.826 68.5291 213.927 46.2581 213.927 46.2581H205.44V81.9548H212.815C212.815 81.9548 212.815 58.6174 212.815 56.7272C213.794 58.4235 227.43 81.9548 227.43 81.9548H235.191V46.2581H227.817H227.805Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.411 60.1926C184.865 58.2175 180.936 56.509 180.936 53.6131C180.936 51.6016 183.149 50.2203 186.437 50.2445C191.708 50.2809 196.894 52.1348 198.489 52.7891L198.937 52.9709V46.7912L198.792 46.7669C197.268 46.5246 192.276 45.7128 187.561 45.7128C178.349 45.7128 172.837 49.2025 172.837 55.0429C172.837 61.2104 178.966 64.0216 184.37 66.4935C188.842 68.5412 193.061 70.4678 193.061 73.9696C193.061 77.7259 187.343 77.8834 186.691 77.8834C183.04 77.8834 178.881 76.7808 173.985 74.2605L173.514 74.0181V80.8885L174.058 81.0218C175.823 81.4337 180.525 82.5364 185.385 82.5364C196.108 82.5364 201.778 78.8286 201.778 71.8249C201.778 65.5968 195.201 62.7251 189.411 60.2047V60.1926Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 100.554V102.299H171.386V105.341H174.094V102.299H179.909V100.554H164Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.15 103.341H166.442V107.752C166.442 108.164 166.793 108.503 167.228 108.503H178.374V106.758H169.15V103.341Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.568 100.785C187.078 100.785 185.047 102.626 185.047 104.88C185.047 107.134 187.078 108.988 189.568 108.988C192.058 108.988 194.089 107.146 194.089 104.88C194.089 102.614 192.058 100.785 189.568 100.785ZM189.568 107.182C188.48 107.182 187.586 106.153 187.586 104.892C187.586 103.632 188.468 102.602 189.568 102.602C190.668 102.602 191.539 103.632 191.539 104.892C191.539 106.153 190.656 107.182 189.568 107.182Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.228 99.4517H177.939V91.9998H175.231V94.508H169.15V91.9998H166.442V98.7005C166.442 99.1124 166.793 99.4517 167.24 99.4517H167.228ZM169.15 96.2528H175.231V97.6947H169.15V96.2528Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.669 91.406H191.961V97.2464C190.099 98.0704 188.105 98.1916 187.077 98.1794H184.369V93.7325H190.232V91.9877H181.649V99.1609C181.649 99.5729 182.012 99.9122 182.447 99.9122H187.089C189.011 99.8879 190.643 99.5729 191.961 99.0034V101.136H194.669V96.7496H197.304V95.0048H194.669V91.3939V91.406Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.818 91.4061V93.5751H290.678V91.9999H287.97V94.2657H284.561V91.9999H281.854V99.161C281.854 99.573 282.204 99.9123 282.651 99.9123H290.678V98.119H292.818V100.76H295.526V91.4061H292.818ZM287.97 98.1674H284.561V95.9985H287.97V98.1674ZM292.818 96.3862H290.678V95.3199H292.818V96.3862Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.425 100.773C287.935 100.773 285.916 102.614 285.916 104.868C285.916 107.122 287.935 108.964 290.425 108.964C292.915 108.964 294.934 107.134 294.934 104.868C294.934 102.602 292.903 100.773 290.425 100.773ZM290.425 107.158C289.337 107.158 288.443 106.128 288.443 104.868C288.443 103.608 289.337 102.578 290.425 102.578C291.513 102.578 292.396 103.608 292.396 104.868C292.396 106.128 291.513 107.158 290.425 107.158Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.119 91.3939V96.6648H207.508V98.4218H210.119V108.806H212.839V91.406H210.119V91.3939Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.651 95.9014H262.028V91.406H259.308V101.16H262.028V97.6584H264.651V95.9135V95.9014Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.16 101.972H278.88V92.3876H266.863V94.1324H276.172V101.972H276.16Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.071 98.7004H272.363V104.892H271.336V98.7004H268.628V104.892H264.445V106.649H280.62V104.892H275.083V98.7004H275.071Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.511 102.348V104.093H259.308V108.794H262.028V102.336H251.511V102.348Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.531 97.101C257.531 96.2043 257.205 95.3683 256.661 94.7018H258.655V92.957H254.545V90.7638H251.825V92.957H247.715V94.7018H249.625C249.069 95.3683 248.742 96.2043 248.742 97.101C248.742 99.3184 250.713 101.112 253.143 101.112C255.573 101.112 257.531 99.3063 257.531 97.101ZM251.317 97.101C251.317 95.8166 252.127 94.7624 253.131 94.7624C254.134 94.7624 254.944 95.8166 254.944 97.101C254.944 98.3854 254.134 99.4396 253.131 99.4396C252.127 99.4396 251.317 98.3854 251.317 97.101Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.198 96.6649C204.836 95.5137 204.824 93.5871 204.824 93.575V92.0725H201.947V93.575C201.947 93.575 201.922 95.5137 201.56 96.6649C200.943 98.7975 199.626 100.712 197.631 102.372L197.534 102.445L198.864 103.656L198.936 103.608C200.907 102.202 202.406 100.615 203.385 98.8823C204.364 100.615 205.863 102.202 207.834 103.608L207.906 103.656L209.236 102.445L209.139 102.372C207.145 100.712 205.815 98.7975 205.211 96.677L205.198 96.6649Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.073 91.3939V96.6648H242.25V91.3939H239.53V99.4396C237.766 100.155 235.916 100.264 234.949 100.251H234.671V93.7325H238.225V91.9877H231.963V101.245C231.963 101.669 232.326 102.008 232.761 102.008H234.973C236.75 101.984 238.273 101.718 239.543 101.221V108.806H242.263V98.4218H243.085V108.806H245.792V91.406H243.085L243.073 91.3939Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.337 99.0155V100.76H221.155V101.863H216.55V103.62H225.471V104.456H216.55V108.043C216.55 108.455 216.9 108.806 217.335 108.806H228.469V107.049H219.535V106.213H228.469V101.875H223.863V100.772H230.681V99.0276H214.325L214.337 99.0155Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.522 98.6035C225.399 98.6035 227.744 96.7496 227.744 94.4838C227.744 92.2179 225.399 90.3761 222.522 90.3761C219.644 90.3761 217.287 92.2179 217.287 94.4838C217.287 96.7496 219.632 98.6035 222.522 98.6035ZM222.522 92.0604C223.767 92.0604 224.782 93.1509 224.782 94.4838C224.782 95.8166 223.767 96.9193 222.522 96.9193C221.276 96.9193 220.261 95.8288 220.261 94.4838C220.261 93.1388 221.276 92.0604 222.522 92.0604Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.634 91.406V99.3184H297.654V101.063H301.245V102.723H303.965V101.063H309.634V101.778H307.096V103.523H309.634V105.135H312.354V91.3939H309.634V91.406Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.977 103.499H301.257V108.055C301.257 108.467 301.619 108.806 302.055 108.806H312.354V107.049H303.977V103.487V103.499Z",
    fill: "#00358C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.228 98.9792C305.718 98.9792 307.737 97.1495 307.737 94.8836C307.737 92.6178 305.718 90.7881 303.228 90.7881C300.737 90.7881 298.73 92.6299 298.73 94.8836C298.73 97.1374 300.749 98.9792 303.228 98.9792ZM303.228 92.5572C304.267 92.5572 305.101 93.6113 305.101 94.8958C305.101 96.1802 304.255 97.2343 303.228 97.2343C302.2 97.2343 301.354 96.1802 301.354 94.8958C301.354 93.6113 302.2 92.5572 303.228 92.5572Z",
    fill: "#00358C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_3664",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(322.332 35.7672) scale(33.4811 33.5593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82C1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#49A9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1494D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#008CCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00358C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 171.975,
    height: 70,
    fill: "white",
    transform: "translate(164 39)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/분당서울대학교병원.cec6b5e08fa3fced281117a3583731db.svg";
export { ForwardRef as ReactComponent };